import { ReactNode } from "react";

interface Props {
  children?: ReactNode;
}

const PublicRoute: React.FC<Props> = ({ children }) => {
  return <>{children}</>;
};

export default PublicRoute;
